export const EMBED_CONSENSUS_LABEL = "PH Consensus";
export const EMBED_CHART_EMPTY = "No data to display";
export const EMBED_POWERED_BY = "Powered by PredictionHero";
export const EMBED_VIEW_EVENT = "View event →";
export const EMBED_VOLUME_SUFFIX = "Vol.";

export const EMBED_INVALID_TITLE = "This embed link is not valid";
export const EMBED_INVALID_HINT =
  "Rebuild it from the Embed dialog on the event page.";

export const EMBED_UNAVAILABLE_TITLE = "Odds are unavailable right now";
export const EMBED_UNAVAILABLE_HINT = "Reload the page in a moment.";

export const EMBED_DOES_NOT_FIT_TITLE = "Content doesn't fit at this size";

export const EMBED_GOLD = "#B29B66";

export const EMBED_DEFAULT_SIZE = { width: 380, height: 385 };

// A sanity ceiling, not a technical limit: the card is fluid and nothing breaks
// above it, but a widget for someone's article has no business being larger.
export const EMBED_MAX_SIZE = { width: 2000, height: 2000 };

export const EMBED_MESSAGE_MIN_SIZE = { width: 260, height: 160 };
